<script>
export let contact;

</script>


<style>

.contact-card {

}

.card-content {
	padding: 1.25rem 1.25rem !important;
}

.contact-name {
	margin-bottom: 0.175rem;
	font-size: 1.175rem;
	color: #1f1f1f;
}

.contact-title {
	font-size: 1.025rem;
	color: #3c3c3c;
	margin-bottom: 0.5rem;
}

.contact-email {
	color: #3c3c3c;
	/*margin-bottom: 0.25rem;*/
}

/*.contact-phone {
	color: #3c3c3c;
}*/

a {
	color: #3c3c3c;
	text-decoration: underline;
}
	
</style>



<div class="card contact-card">

	<div class="card-content">

		<p class="contact-name">
			{contact.name}
		</p>

		<p class="contact-title">
			{contact.title}
		</p>

		<p class="contact-email">
			<a href="mailto:{contact.email}">{contact.email}</a>
		</p>

		<!-- <p class="contact-phone">
			Phone: <a href="tel:{contact.phone}">{contact.phone_print}</a>
		</p> -->


	</div>

</div>

